import { useState, useCallback } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { Button } from '@Components/Button';
import { Background } from '@Components/designConstants';
import { WidgetContainer } from '@Components/WidgetContainer';
import { LinearBuyingLambdaFetch } from '../../../utils/fetch-utils';
import { AdOpsToolProps } from '../adops-constants';

export const LogUpdates = ({ utils }: AdOpsToolProps) => {
  const [activeAPICall, setActiveAPICall] = useState(false);
  const { setError, setModalMessage, setShowModalConfirmation } = utils;

  const [reconcileCompany, setReconcileCompany] = useState('');
  const [reconcileNetwork, setReconcileNetwork] = useState('');
  const [reconcileWeek, setReconcileWeek] = useState('');

  const redoReconcile = useCallback(async () => {
    try {
      setActiveAPICall(true);
      await LinearBuyingLambdaFetch('/resolveSpotsWithReset', {
        method: 'POST',
        body: JSON.stringify({
          week: reconcileWeek,
          network: reconcileNetwork,
          company: reconcileCompany
        })
      });
      setModalMessage(`Re-reconciled ${reconcileCompany}, ${reconcileNetwork}, ${reconcileWeek}`);
      setShowModalConfirmation(true);
    } catch (e) {
      setError({ message: e.message, reportError: e });
    }
    setActiveAPICall(false);
  }, [
    reconcileWeek,
    reconcileNetwork,
    reconcileCompany,
    setModalMessage,
    setShowModalConfirmation,
    setError
  ]);

  const addHTSSpend = useCallback(async () => {
    try {
      setActiveAPICall(true);
      await LinearBuyingLambdaFetch('/update_hts_costs', {
        method: 'POST',
        body: {}
      });
      setModalMessage('HTS Costs Updated');
      setShowModalConfirmation(true);
    } catch (e) {
      setError({ message: e.message, reportError: e });
    }
    setActiveAPICall(false);
  }, [setError, setModalMessage, setShowModalConfirmation]);

  const addVWSESpend = useCallback(async () => {
    try {
      setActiveAPICall(true);
      await LinearBuyingLambdaFetch('/update_vwse_costs', {
        method: 'POST',
        body: {}
      });
      setModalMessage('VWSE Costs Updated');
      setShowModalConfirmation(true);
    } catch (e) {
      setError({ message: e.message, reportError: e });
    }
    setActiveAPICall(false);
  }, [setError, setModalMessage, setShowModalConfirmation]);

  return (
    <WidgetContainer
      className='linear-tool-card'
      header='Log Updates'
      background={Background.DARK}
      dataTestId='log-updates'
    >
      <InputGroup className='ad-ops-elem'>
        <InputGroup.Text className='input-label'>Company</InputGroup.Text>
        <Form.Control
          data-testid='log-updates-company'
          value={reconcileCompany}
          onChange={e => setReconcileCompany(e.target.value)}
        />
        <InputGroup.Text className='input-label'>Network</InputGroup.Text>
        <Form.Control
          data-testid='log-updates-network'
          value={reconcileNetwork}
          onChange={e => setReconcileNetwork(e.target.value)}
        />
        <InputGroup.Text className='input-label'>Week</InputGroup.Text>
        <Form.Control
          data-testid='log-updates-week'
          value={reconcileWeek}
          onChange={e => setReconcileWeek(e.target.value)}
        />
      </InputGroup>
      <div className='ad-ops-elem ad-ops-button-row'>
        <Button data-testid='log-updates-redo' loading={activeAPICall} onClick={redoReconcile}>
          Redo Logs Reconcile
        </Button>
        <Button data-testid='log-updates-hts' loading={activeAPICall} onClick={addHTSSpend}>
          Add HTS Spend
        </Button>
        <Button data-testid='log-updates-vwse' loading={activeAPICall} onClick={addVWSESpend}>
          Add VWSE Spend
        </Button>
      </div>
    </WidgetContainer>
  );
};
